import Swal from 'sweetalert2';

export default class ConfirmUnlock extends HTMLAnchorElement {
    constructor() {
        super();
    }

    connectedCallback() {
        console.log('here');
        this.events();
    }

    events() {
        this.addEventListener('click', (event) => {

            event.stopPropagation();
            event.preventDefault();

            const url = this.getAttribute('href');

            if (!url) {
                console.error('URL non définie pour le lien.');
                return;
            }

            console.log('URL récupérée :', url);

            Swal.fire({
                title: 'Êtes-vous sûr ?',
                text: "",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Oui',
                cancelButtonText: 'Non'
            }).then((result) => {
                console.log('Résultat de Swal.fire :', result);
                if (result && result.value) {
                    console.log('Redirection vers :', url);
                    window.location.assign(url);
                } else {
                    console.log("Action annulée par l'utilisateur.");
                }
            });
        });
    }
}
